// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import Montserrat from Google Fonts */

/* General Styles */
body {
  margin: 0;
  font-family: 'Roboto', sans-serif;
  background-color: #f9f9f9;
  color: #333;
  scroll-behavior: smooth;
}

.App {
  /*padding-top: 10px; !* Offset for sticky navbar *!*/
}

/* Hero Banner */
.hero-banner {
  background: linear-gradient(to right, #800000, #a83232); /* Burgundy Gradient */
  color: #fff;
  padding: 4rem 1rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  font-family: 'Roboto', sans-serif;
}

.hero-content {
  max-width: 900px;
}

.hero-title {
  font-size: 3rem;
  font-weight: bold;
  margin: 0 0 1rem;
  font-family: 'Roboto', sans-serif;
}

.hero-subtitle {
  font-size: 1.5rem;
  line-height: 1.5;
  margin: 0;
  font-family: 'Roboto', sans-serif;
}

/* Page Content */
.page-content {
  padding: 2rem 2rem;
  max-width: 800px;
  margin: 0 auto;
  text-align: left;
}

.page-content p {
  font-size: 1.2rem;
  line-height: 1.8;
  color: #000;
  font-family: 'Roboto', sans-serif;
}

.calendar-wrapper iframe {
  width: 100%;
  height: 70vh;
  border: 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAGxC,mBAAmB;AACnB;EACE,SAAS;EACT,iCAAiC;EACjC,yBAAyB;EACzB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,oDAAoD;AACtD;;AAEA,gBAAgB;AAChB;EACE,uDAAuD,EAAE,sBAAsB;EAC/E,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX","sourcesContent":["/* Import Montserrat from Google Fonts */\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;600;700&display=swap');\n\n/* General Styles */\nbody {\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n  background-color: #f9f9f9;\n  color: #333;\n  scroll-behavior: smooth;\n}\n\n.App {\n  /*padding-top: 10px; !* Offset for sticky navbar *!*/\n}\n\n/* Hero Banner */\n.hero-banner {\n  background: linear-gradient(to right, #800000, #a83232); /* Burgundy Gradient */\n  color: #fff;\n  padding: 4rem 1rem;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n  font-family: 'Roboto', sans-serif;\n}\n\n.hero-content {\n  max-width: 900px;\n}\n\n.hero-title {\n  font-size: 3rem;\n  font-weight: bold;\n  margin: 0 0 1rem;\n  font-family: 'Roboto', sans-serif;\n}\n\n.hero-subtitle {\n  font-size: 1.5rem;\n  line-height: 1.5;\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n}\n\n/* Page Content */\n.page-content {\n  padding: 2rem 2rem;\n  max-width: 800px;\n  margin: 0 auto;\n  text-align: left;\n}\n\n.page-content p {\n  font-size: 1.2rem;\n  line-height: 1.8;\n  color: #000;\n  font-family: 'Roboto', sans-serif;\n}\n\n.calendar-wrapper iframe {\n  width: 100%;\n  height: 70vh;\n  border: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
